import { http } from '../../../Lib/Http/httpClient';
import { deleteLog, setLogs } from '../reducer';
export function getLogs(params) {
    return function (dispatch) {
        return http.client.get('logs', {
            params: params
        }).then(function (response) {
            dispatch(setLogs(response.data.data));
        });
    };
}
export function deleteLogs(params) {
    return function (dispatch) {
        return http.client.delete('logs', {
            params: params
        }).then(function () {
            dispatch(deleteLog(params.fileName));
        });
    };
}
export function downloadLogs(params) {
    return function () {
        return http.client.get('logs/download', {
            params: params,
            responseType: 'blob'
        }).then(function (response) {
            return response;
        });
    };
}
